import React from 'react';
import { format } from 'date-fns';
import { el } from 'date-fns/locale';

export default function ConflictModal({ conflict, onSelectSlot, onClose }) {
  const conflictBooking = conflict?.conflict;
  const suggestedSlots  = conflict?.suggested_slots || [];

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <span className="modal-title">⚠️ Η ώρα δεν είναι διαθέσιμη</span>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {conflictBooking && (
            <div className="conflict-alert">
              <div className="conflict-title">Υπάρχει ήδη κράτηση:</div>
              <div>{conflictBooking.client_name} — {format(new Date(conflictBooking.starts_at), 'HH:mm')}</div>
            </div>
          )}

          {suggestedSlots.length > 0 && (
            <>
              <div className="field"><label>Διαθέσιμες ώρες την ίδια μέρα:</label></div>
              <div className="slots-list">
                {suggestedSlots.map((slot) => (
                  <button key={slot} className="slot-btn" onClick={() => onSelectSlot(slot)}>
                    🕐 {format(new Date(slot), 'HH:mm', { locale: el })} — {format(new Date(slot), 'EEEE d MMMM', { locale: el })}
                  </button>
                ))}
              </div>
            </>
          )}

          {suggestedSlots.length === 0 && (
            <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>
              Δεν υπάρχουν διαθέσιμες ώρες αυτή την ημέρα.
            </p>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Κλείσιμο</button>
        </div>
      </div>
    </div>
  );
}